import { gql, TypedDocumentNode } from "@apollo/client";

export type QueuePbdCardManualFulfillmentResponse = {
  queuePbdCardManualFulfillment: {
    success: boolean;
    message: string;
  };
};

export type QueuePbdCardManualFulfillmentVariables = {
  pgaIds: string[];
};

export const QUEUE_PBD_CARD_MANUAL_FULFILLMENT_MUTATION: TypedDocumentNode<
  QueuePbdCardManualFulfillmentResponse,
  QueuePbdCardManualFulfillmentVariables
> = gql`
  mutation QueuePbdCardManualFulfillment($pgaIds: [String!]!) {
    queuePbdCardManualFulfillment(pgaIds: $pgaIds) {
      success
      message
    }
  }
`;
